/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { SessionService } from '../../services/session2.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { ErrorService } from '../../services/error.service';
import { EventService } from '../../services/event.service';
import { AccountService } from '../../services/account.service';
import { EloquaService } from '../../services/eloqua.service';
import { EloquaCdoService } from '../../services/eloqua-cdo.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { DriftService } from '../../services/drift.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

import { Constants, EmailType, ContactQuality, StaticDate } from '../../global/constants';

import { Animations } from '../../global/animations';

@Component({
  selector: 'app-cdo',
  templateUrl: './cdo.component.html'
})
export class CdoComponent implements OnInit {
  loadingPage: boolean = true;
  session: any;
  currentType: EmailType;
  showAll: boolean = false;
  toggleNoIntegrations: boolean = false;

  selectDialogRef: BsModalRef;

  integrations: any = {
    eloqua: false,
  };

  integrationCount: number = 0;
  singleIntegration: string = '';

  cdoSyncs: Array<any> = [];
  activeSyncs: Array<any> = [];

  syncCount: any = {
    new: 0,
    existing: 0,
  };

  constructor(private sessionService: SessionService,
    private cacheService: CacheService,
    private errorService: ErrorService,
    private eventService: EventService,
    private accountService: AccountService,
    private eloquaCdoService: EloquaCdoService,
    private modalService: BsModalService,
    private globalMessageService: GlobalMessageService,
    private driftService: DriftService,
    private constants: Constants) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  select(dialog) {
    this.selectDialogRef = this.modalService.show(dialog, {class: 'modal-lg'});
  }

  filterType(t: EmailType) {
    this.currentType = t;
    this.session.cdosync_filters.type = t.typeName;
    this.loadCdoSyncs();
    this.saveSession();
  }

  filterCdoType(cdoType: string) {
    this.session.cdosync_filters.cdo_type = cdoType;
    this.setActiveCdoSync();
    this.saveSession();
  }

  toggle(cdo) {
    var msg = 'turned on';
    cdo.enabled = !cdo.enabled;
    if (!cdo.enabled) {
      msg = 'turned off';
      this.driftService.track('disabled-cdoSync', { type: this.cdoType(cdo), id: cdo._id });
    }
    else {
      this.driftService.track('enabled-cdoSync', { type: this.cdoType(cdo), id: cdo._id });
    }
    this.eloquaCdoService.setEnabled(cdo._id, cdo.enabled).subscribe(
      (result: any) => {
        this.globalMessageService.message('cdoSync was ' + msg);
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'cdo.component', 'toggle');
      }
    )
  }

  delete(cdo) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to delete this CDO Sync',
        confirm: function() {
          me.eloquaCdoService.setDeleted(cdo._id).subscribe(
            (result: any) => {
              me.cdoSyncs.splice(me.cdoSyncs.indexOf(cdo), 1);
              me.setActiveCdoSync();
              me.globalMessageService.message('CDO Sync was deleted');
              me.driftService.track('deleted-cdosync', { type: me.cdoType(cdo), id: cdo._id });
            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'cdo.component', 'delete');
            }
          )
        }
      }
    }));
  }

  clone(cdo) {
    var newCDO = JSON.parse(JSON.stringify(cdo));
    newCDO._id = "new";
    delete newCDO.created_at;
    this.eloquaCdoService.saveNew(newCDO).subscribe(
      (result: any) => {
        this.globalMessageService.message('CDO Sync was cloned');
        this.driftService.track('cloned-cdosync', { type: this.cdoType(cdo), id: cdo._id });
        this.loadCdoSyncs();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'cdo.component', 'clone');
      }
    )
  }

  toggleDetail(show: boolean) {
    this.showAll = show;
    this.eventService.toggleAllCdoSyncDetails$.emit(show);
  }

  private initView() {
    //make sure  filters exist for this user
    if (!this.session.cdosync_filters) {
      this.resetFilters();
    }

    var now = new Date();
    var lastUpdate = new Date(this.session.cdosync_filters.last_changed);
    if (now.getTime() - lastUpdate.getTime() > 900000) {
      // 900000ms = 15 minutes. Let's reset filters if it's been more than 15 minutes since they were last last changed
      this.resetFilters();
    }

    this.currentType = this.constants.emailTypes.find((i) => {
      return i.typeName == this.session.cdosync_filters.type;
    });

    this.loadIntegrations();
    this.loadCdoSyncs();
  }

  private loadIntegrations() {
    this.integrationCount = 0;
    this.accountService.getIntegrations().subscribe(
      (result: any) => {
        if (result.eloqua) {
          this.integrations.eloqua = true;
          this.integrationCount++;
          this.singleIntegration = 'eloqua';
        }
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'cdo.component', 'initView');
      });
  }

  private loadCdoSyncs() {
    this.loadingPage = true;
    this.syncCount = {
      new: 0,
      existing: 0,
    };
    this.loadingPage = false;


    this.eloquaCdoService.getSyncs().subscribe(
      (result: any) => {
        this.cdoSyncs = result;
        this.setActiveCdoSync();
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'cdo.component', 'loadWorkflows');
      }
    )
  }

  private setActiveCdoSync() {
    this.activeSyncs = [];
    this.syncCount.new = 0;
    this.syncCount.existing = 0;
    this.syncCount.alert = 0;
    this.cdoSyncs.forEach((s) => {
      if (this.currentType.typeName == 'all' || s.trigger.type.indexOf(this.currentType.typeName) >= 0) {
        if (s.trigger.data == 'contacts') {
          this.syncCount.new++;

          if (s.trigger.type.length == 0) {
            s.invalid = true;
          }
          if (this.session.cdosync_filters.cdo_type == 'contacts') {
            this.activeSyncs.push(s);
          }
        }
        else  { //(s.trigger.data == 'recipient')
          this.syncCount.existing++;
          if (!s.action.list.id && s.action.fields.length == 0 && s.action.static_fields.length == 0) {
            s.invalid = true;
          }
          if (s.trigger.type.length == 0) {
            s.invalid = true;
          }
          if (this.session.cdosync_filters.cdo_type == 'recipient') {
            this.activeSyncs.push(s);
          }
        }
      }
    });

    this.invalidateCdoSync();
  }

  /**
   * It's possible for them to invalidate a workflow that's enabled - let's make sure to disable any if that happens
   */
  private invalidateCdoSync() {
    this.activeSyncs.forEach((cdo) => {
      if (cdo.invalid && cdo.enabled) {
        cdo.enabled = false;
        this.eloquaCdoService.setEnabled(cdo._id, false).subscribe(
          (result: any) => {
            // Nothing
          },
          error => {
            // Supress
          }
        )
      }
    });
  }

  private resetFilters() {
    this.session.cdosync_filters = {
      type: 'all',
      cdo_type: 'contacts',
      sort: {
        field: 'ls_date',
        direction: -1
      }
    };

    this.saveSession();
  }

  private saveSession() {
    this.session.cdosync_filters.last_changed = new Date();
    this.sessionService.saveSession(this.session).subscribe(
      (result: any) => {
        // Nothing
      },
      err => {
        this.errorService.log(err, 'cdo.component', 'saveSession');
      }
    )
  }

  private cdoType(cdo) {
    let type = 'Create contacts';
    if (cdo.trigger.data != 'contacts') {
      type = 'Update contacts';
    }
    return type;
  }
}



// WEBPACK FOOTER //
// ./client/app/config/cdo/cdo.component.ts